import { type LexSlug } from '@/context/LexSlugs';

export const POSTHOG_AB_PREFIX = 'ab_test:';

export const isPostHogSlug = (lexKey: LexSlug) => {
  return lexKey.startsWith(POSTHOG_AB_PREFIX);
};
